// In index.js or App.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ChatBotFile from './chatbotFile/ChatBotFile';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Expose the ChatBot component globally
window.ChatBotFile = ChatBotFile;
